module.exports = __webpack_public_path__ + "static/media/logo_fingo_new.9bfad1ea.png";